// store/slices/workspaceSlice.ts
import { WorkspaceRole } from "@/shared/workspace-permissions";

export interface WorkspaceSummary {
  id: string;
  name: string;
  role: WorkspaceRole;
  isPersonal: boolean;
  status: "active" | "frozen";
  isOwner: boolean;
  // Owner-derived premium status (§WS1): premium FEATURES follow the workspace
  // OWNER's plan, so a Basic member of a Premium workspace still gets Premium.
  isPremium: boolean;
  planType: string;
}

export interface WorkspaceState {
  workspaces: WorkspaceSummary[];
  activeWorkspaceId: string | null;
  workspacesLoaded: boolean;
}

export interface WorkspaceActions {
  setWorkspaces: (workspaces: WorkspaceSummary[]) => void;
  setActiveWorkspaceId: (id: string | null) => void;
}

export const workspaceSlice = (
  set: any,
): { data: WorkspaceState; actions: WorkspaceActions } => ({
  data: {
    workspaces: [],
    activeWorkspaceId: null,
    workspacesLoaded: false,
  },
  actions: {
    setWorkspaces: (workspaces: WorkspaceSummary[]) => {
      set((state: any) => {
        state.data.workspaces = workspaces;
        state.data.workspacesLoaded = true;
      });
    },
    setActiveWorkspaceId: (id: string | null) => {
      set((state: any) => {
        state.data.activeWorkspaceId = id;
      });
    },
  },
});
